var render = function render(){var _vm=this,_c=_vm._self._c;return _c('infoWrapper',{staticClass:"my-10",attrs:{"title":"退款信息"}},[_c('div',{staticClass:"px-20 py-10 w-75"},[_c('inputCenter',{attrs:{"initOptions":_vm.inputList_refundReason}}),(_vm.inputList_refundReason_more)?_c('inputCenter',{attrs:{"initOptions":_vm.inputList_refundReason_more}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }